export default "__VITE_ASSET__B$EQm0QE__"